export type NavigationFeature = {
  label: string;
  path: string;
  // Wider match for sub-pages that are not in the sidebar
  activePath?: string;
};

export type NavigationEnvironment = {
  key: "development" | "production";
  label: string;
  basePath: string;
  features: NavigationFeature[];
};

export type NavigationProduct = {
  key: string;
  name: string;
  initials: string;
  logoPath?: string;
  environments: NavigationEnvironment[];
};

// Only environments with real features are listed, empty ones were placeholders
export const productNavigation: NavigationProduct[] = [
  {
    key: "accelerus",
    name: "Accelerus",
    initials: "AC",
    logoPath: "/accelerus_square_logo.png",
    environments: [
      {
        key: "development",
        label: "Development",
        basePath: "/accelerus/development",
        features: [
          { label: "Power On/Off", path: "/accelerus/development/on-off" },
          { label: "Worker Scaling", path: "/accelerus/development/worker-scaling" },
          { label: "Worker Maintenance", path: "/accelerus/development/worker-maintenance" },
        ],
      },
      {
        key: "production",
        label: "Production",
        basePath: "/accelerus/production",
        features: [
          { label: "DB Elastic Pool", path: "/accelerus/production/elastic-pool" },
          { label: "Worker Scaling", path: "/accelerus/production/worker-scaling" },
          { label: "Worker Maintenance", path: "/accelerus/production/worker-maintenance" },
        ],
      },
    ],
  },
  {
    key: "xuno",
    name: "Xuno",
    initials: "XU",
    logoPath: "/xuno_blue_3d_logo.png",
    environments: [
      {
        key: "production",
        label: "Production",
        basePath: "/xuno/production",
        features: [
          { label: "DB Backup Schedule", path: "/xuno/production/backup-schedule" },
          { label: "DB Backup Retention", path: "/xuno/production/backup-retention" },
          { label: "DB Server Scaling", path: "/xuno/production/server-scaling" },
          { label: "Blob Storage Archive", path: "/xuno/production/blob-archive" },
        ],
      },
    ],
  },
  {
    key: "bpos",
    name: "BPOS",
    initials: "BP",
    logoPath: "/bpos_3D_logo_2.png",
    environments: [
      {
        key: "development",
        label: "Development",
        basePath: "/bpos/development",
        features: [
          { label: "Power On/Off", path: "/bpos/development/on-off" },
        ],
      },
    ],
  },
  {
    key: "gradexpert",
    name: "GradeXpert/Student Maps",
    initials: "GX",
    logoPath: "/gradexpert_3D_logo.png",
    environments: [
      {
        key: "development",
        label: "Development",
        basePath: "/gradexpert/development",
        features: [
          { label: "Power On/Off Staging", path: "/gradexpert/development/on-off/staging" },
          { label: "Power On/Off 16022", path: "/gradexpert/development/on-off/16022" },
        ],
      },
      {
        key: "production",
        label: "Production",
        basePath: "/gradexpert/production",
        features: [
          { label: "Migration", path: "/gradexpert/production/migration/list", activePath: "/gradexpert/production/migration" },
        ],
      },
    ],
  },
];

export function findNavigationContext(pathname: string) {
  for (const product of productNavigation) {
    for (const environment of product.environments) {
      for (const feature of environment.features) {
        const matchPath = feature.activePath ?? feature.path;
        if (pathname === matchPath || pathname.startsWith(`${matchPath}/`)) {
          return { product, environment, feature };
        }
      }
    }
  }

  return null;
}
